function insertStyle(css) {
    if (!css || typeof window === 'undefined')
        return;
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    return css;
}

export { insertStyle as default };
//# sourceMappingURL=____insertStyle.js.map
